import { MultipleSelection } from '../../../../components';
import { useTranslation } from '../../../../hooks';
import { EnumSupportedSystem } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/SwapAgent';

interface IProps {
  label?: string;
  value: string[];
  onChange: (value: string[]) => void;
  onClear: () => void;
}

const SupportedSystemMultipleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { tc, t } = useTranslation('EnumSupportedSystem');

  return (
    <MultipleSelection
      label={label || tc('phSelection', { fieldName: tc('supportedSystem') })}
      value={value || []}
      onChange={onChange}
      clearSelect={onClear}
      enumData={EnumSupportedSystem}
      nameFn={(item) => t(item)}
    />
  );
};

export default SupportedSystemMultipleSelection;
